export const controllerValuesEqual = (valueA, valueB) =>
   Math.abs(valueA - valueB) < 2 ** -30;
